import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/realityCheckWarningScreen.css';
import {getFormattedCurrency, getText} from '../../../helpers/localization';
import {OPERATOR} from '../../../constants/operator';
import Button from './button';
import {openCloseRealityCheckModal} from '../../../actions/realityCheckModalAction';
import {placeBets} from '../helpers/betHelpers';
import {BASE_VALUE} from '../../../constants/chips';


const mapStateToProps = (state, ownProps) => {
    return {
        betsToPlaceAfterRealityCheck: state.vpp.betsToPlaceAfterRealityCheck,
        noMoreBetsEventList: state.vpp.noMoreBetsEventList,
    };
};

class RealityCheckWarningScreen extends Component {

    constructor(props) {
        super(props);
        let store = this.props.store;
        let storeData = store.getState();
        this.state = {
            betsToPlaceAfterRealityCheck: storeData.vpp.betsToPlaceAfterRealityCheck,
            noMoreBetsEventList: storeData.vpp.noMoreBetsEventList
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();
        this.setState({
            betsToPlaceAfterRealityCheck: storeData.vpp.betsToPlaceAfterRealityCheck,
            noMoreBetsEventList: storeData.vpp.noMoreBetsEventList
        });
    }

    componentDidMount() {
        this._closeWhenBetsAreExpired();
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    _placeBets() {
        let betsToPlace = this.state.betsToPlaceAfterRealityCheck;
        this._closeModal();
        placeBets(betsToPlace, this.props.store);
    }

    _closeModal() {
        this.props.store.dispatch(openCloseRealityCheckModal([]));
    }

    _closeWhenBetsAreExpired() {
        this.interval = setInterval(() => {
            let currDate = new Date();
            let expiredBets = this.state.betsToPlaceAfterRealityCheck.filter(bet => {
                if ((bet.bets[0].event.eventTimeDate < currDate.getTime()
                    || this.state.noMoreBetsEventList.find((nmbe) => nmbe.eventId === bet.bets[0].event.eventId
                        && nmbe.gameChannel === bet.bets[0].event.channel))) {
                    return true;//bet expired
                }
                return false;
            });
            if (expiredBets.length > 0) {
                clearInterval(this.interval);
                this._closeModal();
            }
        }, 500);
    }

    render() {
        let rcMaxTotalStake = OPERATOR.rcMaxTotalStake / BASE_VALUE;
        rcMaxTotalStake = getFormattedCurrency(this.props.store, rcMaxTotalStake);
        return (
            <div className={style.container}>
                <div>{getText('REALITY_CHECK_WARNING_MESSAGE_LINE_1', this.props.store, [rcMaxTotalStake])}</div>
                <div>{getText('REALITY_CHECK_WARNING_MESSAGE_LINE_2', this.props.store)}</div>
                <div className={style.buttonContainer}>
                    <div className={style.buttonWrapper}>
                        <Button sbLabel={getText('REALITY_CHECK_WARNING_YES', this.props.store)}
                                circleSize={this.props.circleSize} style={style.customButton}
                                buttonStyle={style.buttonCustomStyle}
                                isEnabled={true} callback={() => this._placeBets()}/>
                    </div>
                    <div className={style.buttonWrapper}>
                        <Button sbLabel={getText('REALITY_CHECK_WARNING_NO', this.props.store)}
                                circleSize={this.props.circleSize} style={style.customButton}
                                buttonStyle={style.buttonCustomStyle}
                                isEnabled={true} callback={() => this._closeModal()}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps)(RealityCheckWarningScreen)



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/realityCheckWarningScreen.js